// // pages/MemberDashboard.js - Updated version
// import { useState, useEffect, useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../api/axiosInstance";
// import { toast } from "react-hot-toast";
// import { AuthContext } from "../context/AuthContext";

// const MemberDashboard = () => {
//   const { logout: logoutContext } = useContext(AuthContext);
//   const [member, setMember] = useState(null);
//   const [dashboardLocked, setDashboardLocked] = useState(false);
//   const navigate = useNavigate();

//   const fetchProfile = async () => {
//     try {
//       const res = await api.get("/profile");
//       const memberData = res.data.member || res.data;

//       setMember(memberData);
//       setDashboardLocked(memberData.dashboardLocked);

//       // Sync localStorage with backend truth
//       localStorage.setItem("dashboardLocked", memberData.dashboardLocked);
//       localStorage.setItem("memberEmail", memberData.email);
//       localStorage.setItem("paymentStatus", memberData.paymentStatus);
//       localStorage.setItem("registrationStatus", memberData.registrationStatus);
//     } catch (error) {
//       console.error("Error fetching member profile:", error);
//       toast.error("Session expired. Please log in again.");
//       logoutContext();
//       localStorage.clear();
//       navigate("/login", { replace: true });
//     }
//   };

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       navigate("/login", { replace: true });
//       return;
//     }

//     fetchProfile();
//   }, [navigate]);

//   const handleLogout = async () => {
//     try {
//       await api.post("/logout");
//     } catch (error) {
//       console.error("Logout error:", error);
//     } finally {
//       localStorage.removeItem("token");
//       localStorage.removeItem("memberEmail");
//       localStorage.removeItem("dashboardLocked");
//       localStorage.removeItem("paymentStatus");
//       localStorage.removeItem("registrationStatus");
//       logoutContext();
//       toast.success("Logged out successfully");
//       navigate("/login", { replace: true });
//     }
//   };

//   const handlePayment = () => {
//     navigate("/payment-checkout");
//   };

//   const navigateToGolfStats = () => {
//     navigate("/golf-statistics");
//   };

//   const navigateToProfile = () => {
//     // You can implement profile page navigation here
//     // toast.success("Profile page coming soon!");
//     navigate("/profile");
//   };

//   const navigateToMembership = () => {
//     // You can implement membership details page here
//     // toast.success("Membership details coming soon!");
//     navigate("/membership-details");
//   };

//   const navigateToEvents = () => {
//     navigate("/upcoming-events");
//   };

//   if (!member) {
//     return (
//       <div className="min-h-screen bg-gray-100 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading dashboard...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100">
//       {/* Header */}
//       <header className="bg-white shadow-sm">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center py-4">
//             <div>
//               <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
//               <p className="text-gray-600">
//                 Welcome back, {member.firstName || member.email.split("@")[0]}!
//               </p>
//             </div>
//             <div className="flex items-center space-x-4">
//               <button
//                 onClick={handleLogout}
//                 className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition"
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {dashboardLocked && (
//           <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
//             <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
//               <div className="text-center">
//                 <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
//                   <svg
//                     className="w-8 h-8 text-yellow-600"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
//                     />
//                   </svg>
//                 </div>
//                 <h3 className="text-xl font-semibold text-gray-900 mb-2">
//                   Membership Payment Required
//                 </h3>
//                 <p className="text-gray-600 mb-6">
//                   Your membership registration has been approved, but payment is
//                   pending. Please complete the payment to unlock your dashboard
//                   features.
//                 </p>
//                 <button
//                   onClick={handlePayment}
//                   className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition font-medium"
//                 >
//                   Complete Membership Registration Payment
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Dashboard Cards */}
//         <div
//           className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${
//             dashboardLocked ? "opacity-50 pointer-events-none" : ""
//           }`}
//         >
//           {/* Profile Card */}
//           <div
//             onClick={dashboardLocked ? undefined : navigateToProfile}
//             className={`bg-white rounded-lg shadow-sm p-6 cursor-pointer hover:shadow-md transition-shadow ${
//               dashboardLocked ? "cursor-not-allowed" : ""
//             }`}
//           >
//             <div className="flex items-center mb-4">
//               <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
//                 <svg
//                   className="w-6 h-6 text-blue-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">Profile</h3>
//             </div>
//             <p className="text-gray-600">
//               View and update your profile information
//             </p>
//           </div>

//           {/* Membership Card */}
//           <div
//             onClick={dashboardLocked ? undefined : navigateToMembership}
//             className={`bg-white rounded-lg shadow-sm p-6 cursor-pointer hover:shadow-md transition-shadow ${
//               dashboardLocked ? "cursor-not-allowed" : ""
//             }`}
//           >
//             <div className="flex items-center mb-4">
//               <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
//                 <svg
//                   className="w-6 h-6 text-green-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Membership
//               </h3>
//             </div>
//             <p className="text-gray-600">
//               Check your membership status and details
//             </p>
//           </div>

//           {/* Golf Statistics Card */}
//           <div
//             onClick={dashboardLocked ? undefined : navigateToGolfStats}
//             className={`bg-white rounded-lg shadow-sm p-6 cursor-pointer hover:shadow-md transition-shadow ${
//               dashboardLocked ? "cursor-not-allowed" : ""
//             }`}
//           >
//             <div className="flex items-center mb-4">
//               <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4">
//                 <svg
//                   className="w-6 h-6 text-purple-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Golf Statistics
//               </h3>
//             </div>
//             <p className="text-gray-600">
//               Track and analyze your golf performance
//             </p>
//           </div>

//           {/* Events Card */}
//           <div
//             onClick={dashboardLocked ? undefined : navigateToEvents}
//             className={`bg-white rounded-lg shadow-sm p-6 cursor-pointer hover:shadow-md transition-shadow ${
//               dashboardLocked ? "cursor-not-allowed" : ""
//             }`}
//           >
//             <div className="flex items-center mb-4">
//               <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
//                 <svg
//                   className="w-6 h-6 text-orange-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-semibold text-gray-900">Events</h3>
//             </div>
//             <p className="text-gray-600">
//               Browse and register for upcoming events
//             </p>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default MemberDashboard;

import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosInstance";
import { toast } from "react-hot-toast";
import { AuthContext } from "../context/AuthContext";
import {
  LogOut,
  User,
  Shield,
  BarChart3,
  Calendar,
  CreditCard,
  Lock,
  CheckCircle,
  Trophy,
  Flag,
  Bell,
  ChevronRight,
  Sparkles,
  Crown,
  Percent,
} from "lucide-react";

const MemberDashboard = () => {
  const { logout: logoutContext } = useContext(AuthContext);
  const [member, setMember] = useState(null);
  const [dashboardLocked, setDashboardLocked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState(3); // Example notification count
  const navigate = useNavigate();

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const res = await api.get("/profile");
      const memberData = res.data.member || res.data;

      setMember(memberData);
      setDashboardLocked(memberData.dashboardLocked);

      // Sync localStorage with backend truth
      localStorage.setItem("dashboardLocked", memberData.dashboardLocked);
      localStorage.setItem("memberEmail", memberData.email);
      localStorage.setItem("paymentStatus", memberData.paymentStatus);
      localStorage.setItem("registrationStatus", memberData.registrationStatus);
    } catch (error) {
      console.error("Error fetching member profile:", error);
      toast.error("Session expired. Please log in again.");
      logoutContext();
      localStorage.clear();
      navigate("/login", { replace: true });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    fetchProfile();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await api.post("/logout");
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("memberEmail");
      localStorage.removeItem("dashboardLocked");
      localStorage.removeItem("paymentStatus");
      localStorage.removeItem("registrationStatus");
      logoutContext();
      toast.success("Logged out successfully");
      navigate("/login", { replace: true });
    }
  };

  const handlePayment = () => {
    navigate("/payment-checkout");
  };

  const navigateToGolfStats = () => {
    navigate("/golf-statistics");
  };

  const navigateToProfile = () => {
    navigate("/profile");
  };

  const navigateToMembership = () => {
    navigate("/membership-details");
  };

  const navigateToEvents = () => {
    navigate("/upcoming-events");
  };

  // const navigateToSettings = () => {
  //   navigate("/settings");
  // };

  const navigateToNotifications = () => {
    // navigate("/notifications");
    toast.success("Notifications page coming soon!");
  };

  const getInitials = (name) => {
    return (
      name
        ?.split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase() || "RG"
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative mb-6">
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-xl opacity-30"></div>
            <div className="relative w-20 h-20 border-4 border-emerald-200 border-t-emerald-500 rounded-full animate-spin"></div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Loading Dashboard
          </h3>
          <p className="text-gray-600">
            Preparing your personalized experience
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Dashboard Locked Modal */}
      {dashboardLocked && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gradient-to-br from-white via-emerald-50/50 to-lime-50/50 rounded-2xl shadow-2xl p-8 max-w-lg w-full border-2 border-emerald-100 transform transition-all duration-500 scale-100">
            <div className="text-center mb-8">
              <div className="relative inline-flex mb-6">
                <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-orange-400 rounded-full blur-lg opacity-40"></div>
                <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-100 flex items-center justify-center shadow-lg">
                  <Lock className="w-10 h-10 text-amber-600" />
                </div>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Complete Your Registration
              </h3>
              <p className="text-gray-600 mb-6">
                Your membership has been approved! Complete the payment process
                to unlock all premium features.
              </p>

              <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl p-6 mb-6 border border-amber-100">
                <div className="flex items-center justify-between mb-4">
                  <div className="text-left">
                    <p className="text-sm text-gray-500">Membership Status</p>
                    <p className="text-lg font-bold text-amber-700">
                      Approved ✓
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-500">Payment Status</p>
                    <p className="text-lg font-bold text-red-600">Pending ⏳</p>
                  </div>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-gradient-to-r from-emerald-400 to-lime-400 h-2 rounded-full"
                    style={{ width: "50%" }}
                  ></div>
                </div>
                <p className="text-sm text-gray-500 mt-2">
                  Step 2 of 2: Complete Payment
                </p>
              </div>

              <button
                onClick={handlePayment}
                className="group w-full py-4 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105"
              >
                <span className="relative flex items-center justify-center gap-3">
                  <CreditCard className="w-5 h-5" />
                  Complete Payment Now
                  <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </span>
              </button>

              <button
                onClick={() => navigate("/contact")}
                className="mt-4 text-emerald-600 hover:text-emerald-800 font-medium transition-colors duration-300"
              >
                Need help? Contact support
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <header className="bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white shadow-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center py-6 gap-4">
            {/* Logo and Title */}
            <div className="flex items-center gap-4">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-md opacity-50"></div>
                <div className="relative w-12 h-12 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center">
                  <Crown className="w-6 h-6 text-white" />
                </div>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold">
                  Member Dashboard
                </h1>
                <p className="text-emerald-200">
                  Welcome back,{" "}
                  <span className="font-semibold">
                    {member.firstName || member.email.split("@")[0]}
                  </span>
                  !
                </p>
              </div>
            </div>

            {/* User Actions */}
            <div className="flex items-center gap-4">
              {/* Notifications */}
              <button
                onClick={navigateToNotifications}
                className="relative p-3 rounded-xl bg-white/10 hover:bg-white/20 transition-colors duration-300"
              >
                <Bell className="w-5 h-5" />
                {notifications > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-r from-red-500 to-orange-500 text-white text-xs rounded-full flex items-center justify-center">
                    {notifications}
                  </span>
                )}
              </button>

              {/* User Avatar */}
              <div className="relative group">
                <div className="w-12 h-12 rounded-full bg-gradient-to-r from-emerald-500 to-lime-500 flex items-center justify-center text-white font-bold text-lg cursor-pointer">
                  {getInitials(member.firstName + " " + member.lastName)}
                </div>
                <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-xl shadow-2xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                  <div className="p-4 border-b border-gray-100">
                    <p className="font-semibold text-gray-900">
                      {member.firstName} {member.lastName}
                    </p>
                    <p className="text-sm text-gray-600 truncate">
                      {member.email}
                    </p>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="flex items-center gap-3 w-full p-3 text-left text-red-600 hover:bg-red-50 transition-colors duration-300 rounded-b-xl"
                  >
                    <LogOut className="w-4 h-4" />
                    Sign Out
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Status Bar */}
          <div className="pb-4">
            <div className="flex flex-wrap items-center gap-4">
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm">
                <CheckCircle className="w-4 h-4 text-emerald-300" />
                <span className="text-sm font-medium">
                  Member ID: {member.memberId || ""}
                </span>
              </div>
              {member.registrationStatus && (
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm">
                  <Shield className="w-4 h-4 text-emerald-300" />
                  <span className="text-sm font-medium capitalize">
                    {member.registrationStatus}
                  </span>
                </div>
              )}
              {member.paymentStatus && (
                <div
                  className={`flex items-center gap-2 px-4 py-2 rounded-full backdrop-blur-sm ${
                    member.paymentStatus === "completed"
                      ? "bg-emerald-500/20 text-emerald-300"
                      : "bg-amber-500/20 text-amber-300"
                  }`}
                >
                  <CreditCard className="w-4 h-4" />
                  <span className="text-sm font-medium capitalize">
                    {member.paymentStatus}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Welcome Card */}
        <div className="mb-8 bg-gradient-to-r from-emerald-500 to-lime-500 rounded-2xl p-8 text-white shadow-2xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-4">
                <Sparkles className="w-6 h-6" />
                <h2 className="text-2xl font-bold">Premium Member Access</h2>
              </div>
              <p className="text-emerald-100 mb-4">
                Welcome to your personalized dashboard. Access exclusive
                features, track your progress, and manage your membership.
              </p>
              {/* <div className="flex items-center gap-4 text-sm">
                <span className="flex items-center gap-2">
                  <Star className="w-4 h-4" />
                  Premium Features
                </span>
                <span className="flex items-center gap-2">
                  <Award className="w-4 h-4" />
                  VIP Services
                </span>
                <span className="flex items-center gap-2">
                  <MapPin className="w-4 h-4" />
                  Club Access
                </span>
              </div> */}
            </div>
            {/* <button
              onClick={navigateToSettings}
              className="px-8 py-3 rounded-xl bg-white text-emerald-600 font-bold hover:bg-emerald-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <span className="flex items-center gap-2">
                <Settings className="w-5 h-5" />
                Settings
              </span>
            </button> */}
          </div>
        </div>

        {/* Dashboard Cards Grid */}
        <div
          className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-500 ${
            dashboardLocked ? "opacity-50 pointer-events-none blur-sm" : ""
          }`}
        >
          {/* Profile Card */}
          <div
            onClick={navigateToProfile}
            className="group bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-lg hover:shadow-2xl cursor-pointer transition-all duration-500 hover:-translate-y-2"
          >
            <div className="flex items-start justify-between mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
                <User className="w-7 h-7 text-blue-600" />
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 group-hover:translate-x-2 transition-all duration-300" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Profile</h3>
            <p className="text-gray-600 mb-6">
              View and manage your personal information and preferences
            </p>
            <div className="flex items-center text-sm text-blue-600 font-medium">
              <span>Update Details</span>
            </div>
          </div>

          {/* Membership Card */}
          <div
            onClick={navigateToMembership}
            className="group bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-lg hover:shadow-2xl cursor-pointer transition-all duration-500 hover:-translate-y-2"
          >
            <div className="flex items-start justify-between mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center">
                <Shield className="w-7 h-7 text-emerald-600" />
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 group-hover:translate-x-2 transition-all duration-300" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Membership</h3>
            <p className="text-gray-600 mb-6">
              View your membership status, benefits, and renewal information
            </p>
            <div className="flex items-center text-sm text-emerald-600 font-medium">
              <span>View Details</span>
            </div>
          </div>

          {/* Golf Statistics Card */}
          <div
            onClick={navigateToGolfStats}
            className="group bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-lg hover:shadow-2xl cursor-pointer transition-all duration-500 hover:-translate-y-2"
          >
            <div className="flex items-start justify-between mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center">
                <BarChart3 className="w-7 h-7 text-purple-600" />
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 group-hover:translate-x-2 transition-all duration-300" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Golf Statistics
            </h3>
            <p className="text-gray-600 mb-6">
              Track your performance, handicaps, and tournament results
            </p>
            <div className="flex items-center text-sm text-purple-600 font-medium">
              <span>View Analytics</span>
            </div>
          </div>

          {/* Events Card */}
          <div
            onClick={navigateToEvents}
            className="group bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-lg hover:shadow-2xl cursor-pointer transition-all duration-500 hover:-translate-y-2"
          >
            <div className="flex items-start justify-between mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center">
                <Calendar className="w-7 h-7 text-amber-600" />
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 group-hover:translate-x-2 transition-all duration-300" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Events & Tournaments
            </h3>
            <p className="text-gray-600 mb-6">
              Browse upcoming events, register, and view past tournaments
            </p>
            <div className="flex items-center text-sm text-amber-600 font-medium">
              <span>Browse Events</span>
            </div>
          </div>

          {/* Pro Shop Card */}
          <div
            onClick={() => navigate("/pro-shop")}
            className="group bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-lg hover:shadow-2xl cursor-pointer transition-all duration-500 hover:-translate-y-2"
          >
            <div className="flex items-start justify-between mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-red-50 to-rose-50 flex items-center justify-center">
                <Trophy className="w-7 h-7 text-red-600" />
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 group-hover:translate-x-2 transition-all duration-300" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Pro Shop</h3>
            <p className="text-gray-600 mb-6">
              Exclusive member discounts on premium golf equipment
            </p>
            <div className="flex items-center text-sm text-red-600 font-medium">
              <span className="flex items-center gap-1">
                <Percent className="w-4 h-4" />
                Member Discounts
              </span>
            </div>
          </div>

        </div>

        {/* Quick Stats */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Last Round</p>
                {/* <p className="text-2xl font-bold text-gray-900">78</p> */}
              </div>
              <Flag className="w-10 h-10 text-emerald-500" />
            </div>
          </div>
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Handicap Index</p>
                {/* <p className="text-2xl font-bold text-gray-900">12.5</p> */}
              </div>
              <BarChart3 className="w-10 h-10 text-purple-500" />
            </div>
          </div>
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-100 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">Next Event</p>
                {/* <p className="text-2xl font-bold text-gray-900">Dec 25</p> */}
              </div>
              <Calendar className="w-10 h-10 text-amber-500" />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MemberDashboard;
